import { render, staticRenderFns } from "./baseLabelFrame.vue?vue&type=template&id=1fa3944f&scoped=true&"
import script from "./baseLabelFrame.vue?vue&type=script&lang=js&"
export * from "./baseLabelFrame.vue?vue&type=script&lang=js&"
import style0 from "./baseLabelFrame.vue?vue&type=style&index=0&id=1fa3944f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa3944f",
  null
  
)

export default component.exports